import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, HelpCircle } from 'lucide-react';
export function ConfrontationSection() {
  return <section className="py-24 bg-white text-slate-900 relative overflow-hidden" data-id="element-21">
      <div className="max-w-4xl mx-auto px-4 relative z-10" data-id="element-22">
        {/* Part 1: The Reality Check */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-20" data-id="element-23">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-amber-50 mb-8 border border-amber-200" data-id="element-24">
            <AlertTriangle className="w-8 h-8 text-amber-600" data-id="element-25" />
          </div>
          <h2 className="text-3xl md:text-5xl font-bold mb-8 leading-tight text-slate-900" data-id="element-26">
            Arrancaste el año en{' '}
            <span className="text-amber-600" data-id="element-27">modo acción</span>.
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-lg font-medium text-slate-700 mb-12" data-id="element-28">
            <div className="bg-slate-50 p-6 rounded-xl border border-slate-200" data-id="element-29">
              Agenda llena
            </div>
            <div className="bg-slate-50 p-6 rounded-xl border border-slate-200" data-id="element-30">
              Equipo activo
            </div>
            <div className="bg-slate-50 p-6 rounded-xl border border-slate-200" data-id="element-31">
              Objetivo claro: facturar
            </div>
          </div>

          <div className="bg-amber-50 p-8 rounded-2xl border border-amber-200" data-id="element-32">
            <p className="text-2xl md:text-3xl font-semibold text-slate-900 mb-6" data-id="element-33">
              Pero dime algo —con honestidad—
            </p>
            <div className="flex items-start gap-4 text-left max-w-2xl mx-auto" data-id="element-34">
              <HelpCircle className="w-8 h-8 text-amber-600 flex-shrink-0 mt-1" data-id="element-35" />
              <div data-id="element-36">
                <p className="text-xl text-slate-900 font-bold mb-2" data-id="element-37">
                  ¿Ya evaluaste de verdad tus resultados 2025?
                </p>
                <p className="text-slate-600 text-lg" data-id="element-38">
                  No lo que intentaste. Lo que lograste y pudiste sostener.
                </p>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Part 2: The Leadership Confrontation */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative" data-id="element-39">
          <div className="absolute left-0 top-0 bottom-0 w-1 bg-gradient-to-b from-amber-500 to-transparent opacity-50 rounded-full" data-id="element-40" />
          <div className="pl-8 md:pl-12" data-id="element-41">
            <h3 className="text-2xl md:text-4xl font-bold mb-8 text-slate-900" data-id="element-42">
              Si hoy tu equipo te preguntara:
              <br data-id="element-43" />
              <span className="text-slate-600" data-id="element-44">
                "¿Cuál es el plan claro para 2026?"
              </span>
            </h3>

            <p className="text-xl text-slate-700 mb-12 leading-relaxed" data-id="element-45">
              ¿Responderías con claridad… o con entusiasmo bien intencionado?
            </p>

            <div className="bg-amber-50 border-l-4 border-amber-500 p-6 md:p-8 rounded-r-xl mb-12" data-id="element-46">
              <p className="text-xl md:text-2xl font-bold text-slate-900 leading-relaxed" data-id="element-47">
                Accionar sin claridad, sin detectar fugas y sin un plan real de
                crecimiento{' '}
                <span className="text-amber-600" data-id="element-48">no es liderazgo</span>.
                <br data-id="element-49" />
                <br data-id="element-50" />
                Es desgaste bien organizado.
              </p>
            </div>

            <div className="space-y-6 text-lg text-slate-700" data-id="element-51">
              <p data-id="element-52">
                El crecimiento sostenible no se construye con motivación. Se
                construye con:
              </p>
              <ul className="flex flex-wrap gap-4" data-id="element-53">
                {['Claridad', 'Foco', 'Sistemas Simples'].map(item => <li key={item} className="px-4 py-2 bg-slate-100 rounded-lg font-semibold text-slate-900 border border-slate-200" data-id="element-54">
                    {item}
                  </li>)}
              </ul>
              <p className="pt-4 border-t border-slate-200" data-id="element-55">
                Y esto pesa aún más cuando lideras equipos. Porque tu forma de
                jugar no solo te afecta a ti. También se replica en quienes
                confían en tu dirección.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}